/**
 * Subscription date arithmetic — US-805 AC3 and US-806 AC2.
 *
 * Kept out of the modal so it can be unit-tested without a DOM: the rule is the
 * one thing in the grant flow that is easy to get wrong and expensive to get
 * wrong (a student loses days they paid for, or gains days they did not).
 *
 * The server recomputes this in the `subscription-grant` edge function; this
 * copy exists so the operator sees the resulting date before confirming.
 */
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

export function computeNewExpiry(
  durationDays: number,
  currentExpiry?: string | null,
  now: Dayjs = dayjs(),
): Dayjs {
  // Extending a live subscription starts at its expiry; granting to someone
  // with none, or whose last one has lapsed, starts today.
  const base = currentExpiry && dayjs(currentExpiry).isAfter(now) ? dayjs(currentExpiry) : now
  return base.add(durationDays, 'day')
}
